<template>
  <div class="base-height recording">
    <header>
      <b>underConstruction</b>
      <i class="material-icons">warning</i>
      <h1>NOBA LAB</h1>
      <p>{{ $t("phrase.easyRecording") }}</p>
    </header>
    <div class="title">
      {{ $t("web") }} {{ $t("audio") }}
      <span>{{ $t("recording") }}</span>
    </div>
    <section class="wave-box">
      <div v-show="!wavesurfer" class="wave-cover">
        <img src="../../assets/images/logo.png" alt />
        <p>{{ $t("phrase.startRecording") }}</p>
      </div>
      <div v-show="wavesurfer" class="wave-form">
        <div id="waveform"></div>
        <div id="waveform-timeline"></div>
      </div>
      <div v-if="!wavesurfer" id="waveform-microphone"></div>
    </section>
    <!-- <a href="/amplitude">Amplitude</a> -->
    <div v-if="playerStatus != 'none'" class="player">
      <div class="play">
        <button class="red" @click="reset">
          <i class="large material-icons">refresh</i>
        </button>
        <button class="primary" @click="play">
          <i v-if="onPlay" class="material-icons">play_arrow</i>
          <i v-else class="material-icons">stop</i>
        </button>
        <a :href="url" download>
          <i class="material-icons">get_app</i>
        </a>
      </div>
      <!-- <div class="noise-cancel">
        <button class="black" @click="save">Cloud Save</button>
      </div>-->
    </div>
    <section v-else class="recording-box">
      <div class="btn-group">
        <button v-if="!recording" class="recording-roundBtn red" @click="recordAndStop">
          <i class="material-icons">mic_none</i>
        </button>
        <button v-else class="timer-btn red" @click="recordStop">
          <i class="material-icons">stop</i>
          <p class="timer">{{ timer }}</p>
        </button>
        <!-- <button
          v-show="recording"
          class="recording-roundBtn black"
          @click="PauseAndRecord"
        >
          <i v-if="isPause" class="material-icons">pause</i>
          <i v-else class="material-icons">play_arrow</i>
        </button>-->
      </div>
      <div v-show="!recording">
        <div class="select-group">
          <div class="select1">
            <select v-model="encodingType">
              <option value="wav">wav</option>
              <option value="mp3">mp3</option>
              <option value="ogg">ogg</option>
            </select>
            <select v-model="numChannels">
              <option :value="1">1 channel</option>
              <option :value="2">2 channel</option>
              <option :value="4">4 channel</option>
              <option :value="8">8 channel</option>
            </select>
          </div>
          <select class="hidden"></select>
          <!-- </div> -->
          <!-- <div class="select-group"> -->
          <div class="select2">
            <select v-model="bitRate">
              <option value="64">64 Kbps</option>
              <option value="128">128 Kbps</option>
              <option value="160">160 Kbps</option>
              <option value="192">192 Kbps</option>
              <option value="224">224 Kbps</option>
              <option value="256">256 Kbps</option>
            </select>
            <select v-model="sampleRate">
              <option value="32000">32000 khz</option>
              <option value="44100">44100 khz</option>
              <option value="48000">48000 khz</option>
            </select>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="process">
        <div class="process-box">
          <i class="large material-icons">mic_none</i>
          <h1>Record</h1>
          {{ $t("phrase.record1") }}
        </div>
        <i class="large material-icons">keyboard_arrow_right</i>
        <div class="process-box">
          <i class="large material-icons">headset</i>
          <h1>Listen</h1>
          {{ $t("phrase.record2") }}
        </div>
        <i class="large material-icons">keyboard_arrow_right</i>
        <div class="process-box">
          <i class="large material-icons">download</i>
          <h1>Download</h1>
          {{ $t("phrase.record3") }}
        </div>
      </div>
      <div class="ad-box">{{ $t("advertise") }}</div>
    </section>
    <!-- <p label="Sound Name">{{ title }}</p> -->
    <Usage />
    <transition name="fade">
      <div v-if="visible" class="dim on">
        <SaveFile :fileUrl="fileUrl" :blob="blob" :size="blob.size" :type="blob.type" />
      </div>
    </transition>
  </div>
</template>
<script>
/*global WebAudioRecorder*/
import SaveFile from "@/components/modal/SaveFile";
import Usage from "@/components/Usage_recording";
import { createNoiseCancel, getHome } from "@/api/index";
// import TimelinePlugin from "@/plugins/timeline.js";
// import microphone from "@/plugins/microphone.js";
import { eventBus } from "@/main";
import { uploadFile } from "@/api/index";
import { mapState } from "vuex";
export default {
  components: { SaveFile, Usage },
  data() {
    return {
      visible: false,
      microphone: "",
      recordingStatus: "Recording",
      playerStatus: "none",
      recording: false,
      isPause: true,
      onPlay: false,
      title: "",
      recorder: null,
      blob: "",
      stream: null,
      encodingType: "wav",
      numChannels: 1,
      bitRate: "128",
      sampleRate: "44100",
      wavesurfer: "",
      minPxPerSec: 10,
      scrollParent: true,
      timer: 0,
      interval: "",
      fileUrl: "",
      url: ""
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 1);
  },
  computed: {
    ...mapState(["isLogin"]),
    cantSave() {
      //check title and recording
      // if (this.title === "") return true;
      if (this.blob && this.recordingStatus == "Recording") {
        return false;
      } else return true;
    }
  },
  mounted() {
    this.recorderStopTimer();
    this.set();
    eventBus.$on("closeModal", message => {
      this.closeModal();
    });
  },
  beforeDestroy() {
    this.blob = null;
    this.timer = null;
    this.wavesurfer = this.wavesurfer ? this.wavesurfer.destroy() : null;
    this.wavesurfer = null;
    this.playerStatus = "none";
    this.microphone.stopDevice();
    this.microphone = null;
  },
  methods: {
    closeModal() {
      this.visible = false;
    },
    set() {
      window.console.log("getHome !!!");
      getHome().then(res => {
        if (res.status === 200) {
          window.console.log("getHome res", res);
        }
      });
    },
    callback_progress_bar(percent) {
      window.console.log("progress bar: " + percent + "%");
    },

    callback_on_close(code, output_filename) {
      let success_fail =
        code == 0 ? "Job Success" : "Job failed by unknown problem";
      window.console.log(success_fail);
      if (code == 0) {
        window.console.log("output file name=" + output_filename);
      }
    },
    handleNoiseCancel() {
      window.console.log("handleNoiseCancel1111");
      const formdata = new FormData();
      window.console.log("this.file", this.file);

      formdata.append("file", this.file);
      createNoiseCancel(formdata).then(res => {
        if (res.status === 200) {
          window.console.log("sendFile res", res);
          this.addFilePath(res.data.path);
        }
      });
    },

    async recordAndStop() {
      window.console.log("this.recording", this.recording);
      if (this.recording) {
        this.stream.getAudioTracks()[0].stop();
        this.recorder.finishRecording();
        this.playerStatus = "none"; //플레이어 화면 노출여부 판단
        this.recording = false; //녹음 중인지 아닌지,
        this.onPlay = true;
        window.console.log("this.recording", this.recording);
        return;
      }

      window.console.log("begin record");

      var constraints = {
        audio: true,
        video: false
      };

      this.stream = await navigator.mediaDevices.getUserMedia(constraints);

      var audioContext = new AudioContext();
      var input = audioContext.createMediaStreamSource(this.stream);

      let configs = {
        workerDir: "/web-audio-recorder/",
        encoding: this.encodingType,
        numChannels: this.numChannels
      };
      window.console.log("configs", configs);

      this.recorder = new WebAudioRecorder(input, configs);

      this.recorder.setOptions({
        timeLimit: 300000, // 단위 초
        encodeAfterRecord: true,
        ogg: { quality: 0.5 },
        mp3: { bitRate: 160 }
      });

      this.recorder.onComplete = (recorder, blob) => {
        window.console.log("onComplete", blob);
        window.console.log("recorder", recorder);
        this.recordingStatus = "Recording";
        this.blob = blob;
        this.url = (window.URL || window.webkitURL).createObjectURL(blob);
        window.console.log("url", this.url);
      };
      this.record();
      this.recorder.startRecording();
      this.recorderStartTimer();
      // window.console.log("time", this.recorder.getCurrentTime());

      this.recordingStatus = "Stop";
      this.recording = true;
      this.blob = null;
      window.console.log("ok it worked");
    },
    record() {
      var wavesurfer = WaveSurfer.create({
        container: "#waveform-microphone",
        waveColor: "black",
        interact: false,
        cursorWidth: 0
        // cursorColor: "rgba(0, 0, 0, 0.0)", //to avoid
      });

      this.microphone = Object.create(WaveSurfer.Microphone);

      this.microphone.init({
        wavesurfer: wavesurfer
      });

      this.microphone.on("deviceReady", function(stream) {
        console.log("Device ready!", stream);
      });
      this.microphone.on("deviceError", function(code) {
        console.warn("Device error: " + code);
      });

      this.microphone.start();
      this.recording = true;
      // pause rendering
      //wavesurfer.microphone.pause();

      // resume rendering
      //wavesurfer.microphone.play();

      // stop visualization and disconnect microphone
      //wavesurfer.microphone.stopDevice();

      // same as stopDevice() but also clears the wavesurfer canvas
      //wavesurfer.microphone.stop();

      // destroy the plugin
      //wavesurfer.microphone.destroy();
    },
    recordStop() {
      this.onPlay = true;
      window.console.log("recordStop");
      this.stream.getAudioTracks()[0].stop();
      this.recorder.finishRecording();
      this.microphone.stop();
      this.recorderStopTimer();
      // this.wavesurfer.destroy();
      window.console.log("microphone.stopDevice");

      // this.wavesurfer.un("ready", () => {
      //   this.wavesurfer.destroy();
      // });
      this.playerStatus = "ready";
      this.recording = false;
    },
    PauseAndRecord() {
      window.console.log("this.recording", this.recorder);
      window.console.log("pauseButton clicked ");
      if (this.recorder.isRecording()) {
        //pause
        this.recorder.finishRecording();
        this.isPause = false;
        clearInterval(this.interval);
      } else {
        //resume
        this.recorder.startRecording();
        this.isPause = true;
        this.recorderStartTimer();
      }
      window.console.log("this.recording", this.recording);
    },
    play1() {
      var wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "purple"
      });
      // let src = window.URL.createObjectURL(this.blob);
      wavesurfer.load(
        "https://ia902606.us.archive.org/35/items/shortpoetry_047_librivox/song_cjrg_teasdale_64kb.mp3"
      );

      wavesurfer.on("ready", function() {
        var timeline = Object.create(WaveSurfer.Timeline);

        timeline.init({
          wavesurfer: wavesurfer,
          container: "#waveform-timeline"
        });
      });
    },
    play() {
      window.console.log("play");
      let src = "";
      this.onPlay = false;
      window.console.log("this.playerStatus", this.playerStatus);
      if (this.playerStatus == "ready") {
        this.playerStatus = "play";
        src = window.URL.createObjectURL(this.blob);
        let wavesurfer = "";
        wavesurfer = WaveSurfer.create({
          container: "#waveform",
          waveColor: "blue",
          progressColor: "orange",
          responsive: true,
          scrollParent: true,
          backgroundColor: "orange",
          closeAudioContext: true,
          showTime: true,
          numberOfInputChannels: this.numChannels
          // plugins: [
          //   WaveSurfer.timeline.create({
          //     container: "#wave-timeline"
          //   })
          // ]
        });
        wavesurfer.load(src);
        wavesurfer.on("ready", function() {
          let timeline = Object.create(WaveSurfer.Timeline);
          // let timeline = Object.create(TimelinePlugin);
          window.console.log("tiemline", timeline);
          timeline.init({
            wavesurfer: wavesurfer,
            container: "#waveform-timeline"
          });
          wavesurfer.play();
        });
        this.wavesurfer = wavesurfer;
        this.wavesurfer.on("finish", () => {
          this.onPlay = true;
          this.playerStatus = "stop";
        });
      } else if (this.playerStatus == "play") {
        this.wavesurfer.pause();
        this.playerStatus = "pause";
        this.onPlay = true;
      } else {
        this.wavesurfer.play();
        this.onPlay = false;
        this.playerStatus = "play";
      }
    },
    recorderStartTimer() {
      // this.timer = this.recorder.recordingTime();
      window.console.log("this.timer", this.timer);
      window.console.log(
        "this.recorder.recordingTime",
        this.recorder.recordingTime()
      );

      this.interval = setInterval(() => {
        this.timer = parseInt(this.recorder.recordingTime());
        window.console.log("recordingTime", this.recorder.recordingTime());
      }, 1000);
    },
    recorderStopTimer() {
      clearInterval(this.interval);
    },
    async save() {
      if (this.isLogin == false) {
        return alert("로그인 후 사용 가능합니다.");
      }
      let formdata = new FormData();
      formdata.append("file", this.blob);

      uploadFile(formdata).then(res => {
        if (res.status === 200) {
          this.fileUrl = res.data.path;
          this.visible = true;

          // this.addFilePath(res.data.path);
        }
      });
    },
    async reset() {
      let result = confirm("녹음 스트림을 리셋 하시겠습니까?");

      if (!result) {
        return;
      }
      this.blob = null;
      this.timer = null;
      this.wavesurfer = this.wavesurfer ? this.wavesurfer.destroy() : null;
      this.wavesurfer = null;
      this.playerStatus = "none";
      this.microphone.stopDevice();
      this.microphone = null;
    }
  }
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 350px;
  background: url("../../assets/images/main-bg.jpg") no-repeat center center;
  background-size: cover;
  color: #fff;
  padding-top: 100px;
  margin-top: 62px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  font-size: 1.6rem;
  letter-spacing: 1px;
  h1 {
    font-size: 4.5rem;
    letter-spacing: 0.5rem;
    margin: 2rem 0;
  }
  i {
    vertical-align: bottom;
  }
  text-align: center;
}
.title {
  font-size: 2.2rem;
  margin-top: 5rem;
  text-align: center;
  span {
    color: #ff5252;
  }
}
.ad-box {
  max-width: 800px;
  margin: 0 auto;
  height: 100px;
  border-radius: 4px;
  border: 1px solid #eee;
}
.wave-box {
  max-width: 800px;
  height: 170px;
  border-radius: 4px;
  overflow: hidden;
  background: linear-gradient(#ffffff, #f2f2f2);
  text-align: center;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  margin: 50px auto;
  padding: 5px 10px 2px 10px;
  position: relative;
  border: 1px solid #313da1;
  .wave-cover {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 50px;
      height: 50px;
    }
    p {
      font-size: 1.5rem;
      color: #000;
      text-align: center;
      padding-top: 25px;
    }
  }
  .wave-form {
    width: 100%;
    height: 100%;
    overflow: hidden;
    #waveform {
      width: 100%;
      height: 85%;
    }
  }
  #waveform-microphone {
    height: 100%;
    canvas {
      height: 90%;
    }
  }
}
.recording-box {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 4px;
  position: relative;
  .select-group {
    width: 100%;
    height: 100px;
    border-radius: 4px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background: linear-gradient(#ffffff, #f2f2f2);
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 0;
    left: 0;
    > div {
      // width: 40%;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
    }
    select {
      width: 12rem !important;
      height: 3.4rem !important;
      margin: 0 20px;
      // background-color: $primary;
      // color: #fff;
    }
    .hidden {
      // width: 30%;
      visibility: hidden;
    }
  }
}
.btn-group {
  max-width: 800px;
  margin: 0 auto;
  height: 100px;
  border-radius: 4px;
  background: linear-gradient(#ffffff, #f2f2f2);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  display: flex;
  justify-content: center;
  .recording-roundBtn {
    margin: 25px;
    width: 50px;
    height: 50px;
    // border: 2px solid blue;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-size: 15px;
    cursor: pointer;
    z-index: 10;
    i {
      font-size: 30px;
    }
    &.red {
      background-color: #ff5252;
      border: 1px solid rgba(255, 255, 255, 0.9);
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
    }
    &.black {
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      color: black;
      border: 1px solid rgba(255, 255, 255, 0.9);
    }
    &.white {
      border: 1px solid #111;
      background-color: #fff;
      i {
        color: #111;
      }
    }
  }
  .timer-btn {
    margin: 25px;
    width: 90px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    color: #ffffff;
    text-align: center;
    font-size: 15px;
    cursor: pointer;
    &.red {
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      color: red;
    }
    &.black {
      border: 1px solid #111;
      background-color: #111;
    }
    &.white {
      border: 1px solid #111;
      background-color: #fff;
      i {
        color: #111;
      }
    }
    .material-icons {
      font-size: 30px;
    }
  }
}
.player {
  max-width: 800px;
  margin: 40px auto;
  height: 100px;
  border-radius: 4px;
  background: linear-gradient(#ffffff, #f2f2f2);
  text-align: center;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-evenly;
  .play {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    i {
      line-height: 50px;
      font-size: 30px;
    }
    a {
      margin: 20px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.9);
      // background-color: rgba(255,255,255,0.6);
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      i {
        line-height: 50px;
        font-size: 30px;
      }
    }
  }
  .noise-cancel {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    button {
      width: 140px;
      height: 40px;
      border-radius: 10px;
      color: #fff;
      font-size: 14px;
      background: #ff5252;
      border: 1px solid rgba(255, 255, 255, 0.9);
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
    }
  }
  button {
    margin: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #111;
    text-align: center;
    font-size: 15px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    cursor: pointer;
    &.black {
      // box-shadow: 0 3px 6px rgba(33,33,33,.1), 0 3px 12px rgba(33,33,33,.15);
      background: #313da1;
    }
    &.red {
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      // color: red;
    }
    &.primary {
      line-height: 50px;
      font-size: 30px;
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      // color: blue;
    }
    &.white {
      border: 1px solid #111;
      background-color: #fff;
      i {
        color: #111;
      }
    }
  }
}

@media all and (max-width: 1200px) {
  header {
    height: 250px;
    padding-top: 60px;
  }
  .wave-box {
    width: calc(100% - 60px);
  }
  .recording-box {
    width: calc(100% - 60px);
  }
  .ad-box {
    width: calc(100% - 60px);
  }
  .player {
    width: calc(100% - 60px);
  }
}

@media screen and (max-width: 540px) {
  header {
    height: 200px;
    padding-top: 30px;
    h1 {
      font-size: 4rem;
      margin: 2.4rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 4rem;
    padding: 0 20px;
  }
  .wave-box {
    height: 130px;
    margin: 4rem auto;
    .wave-cover {
      width: 100%;
      p {
        padding-top: 15px;
      }
    }
  }
  .recording-box {
    margin-bottom: 4rem;
    .select-group {
      height: 90px;
      margin: 0 auto;
      flex-direction: column;
      justify-content: space-evenly;
      > div {
        width: 90%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        margin: 0;
      }
      select {
        width: 12rem !important;
        height: 3.4rem !important;
        margin: 0;
      }
    }
  }
  .btn-group {
    width: 100%;
    height: 90px;
    margin: 0 auto;
    .recording-roundBtn {
      margin: 20px;
      width: 50px;
      height: 50px;
    }
  }
  .timer-btn {
    margin: 25px;
    &.red {
      margin-top: 20px;
    }
  }

  .player {
    margin: 4rem auto;
    height: 80px;
    .play {
      i {
        line-height: 40px;
        font-size: 24px;
      }
      a {
        margin: 10px;
        width: 40px;
        height: 40px;
        i {
          line-height: 40px;
          font-size: 24px;
        }
      }
    }
    .noise-cancel {
      button {
        width: 100px;
        height: 40px;
        font-size: 14px;
      }
    }
    button {
      margin: 10px;
      width: 40px;
      height: 40px;
      font-size: 15px;
      &.primary {
        line-height: 40px;
        font-size: 24px;
      }
    }
  }
  .ad-box {
    margin: 6rem auto 1rem;
    height: 80px;
    border: 1px solid #eee;
  }
}

@media all and (max-width: 376px) {
  header {
    font-size: 1.5rem;
    h1 {
      font-size: 4rem;
      margin: 2rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 2.5rem;
  }
  .wave-box {
    margin-top: 3rem;
    width: calc(100% - 20px);
  }
  .recording-box {
    width: calc(100% - 20px);
  }
  .ad-box {
    width: calc(100% - 20px);
  }
  .player {
    width: calc(100% - 20px);
  }

  .recording-box {
    .select-group {
      > div {
        width: 90%;
      }
      select {
        width: 11rem !important;
        height: 3rem !important;
      }
    }
  }
}
</style>
